import React, { useContext, useEffect } from "react";
import logo from "../../images/llac-logo.png";
import {withRouter} from 'react-router-dom'
import queryString from "query-string";
import MainContext from '../../state/main/mainContext'
import ReactGA from 'react-ga';

const Modal1 = ({history: {push}, location}) => {
  const mainContext = useContext(MainContext)
  const {onIframe, iframe} = mainContext;
  useEffect(() => {
    const query = queryString.parse(location.search);
    if (query.iframe) {
      onIframe()
      console.log({iframe, msg: 'did this work?'})
    }
    ReactGA.pageview(window.location.pathname); 
  }, [iframe])

  const moveForward = () => {
    push('/survey/1/')
  }
  return (
    <section id="modal-1">
      <div className="container">
        <div className="top">
          <img src={logo} alt="" />
          <h2>Graduation Estimator</h2>
        </div>
        <div className="middle">
          <p>At Learn4Life, every day is Graduation Day.</p>
          <p>
            Whether you’re behind and need to catch up on credits, or you want
            to work faster and graduate early, our teachers will work with you
            to develop the best plan to meet your needs.
          </p>
          <p>
            Click below to access our Graduation Estimator tool, and see how
            quickly Learn4Life can help you <br/> <strong>Change Your Story!</strong>
          </p>
        </div>
        <div onClick={moveForward} className="btn btn-red">
          Get Started
        </div>
      </div>
    </section>
  );
};

export default withRouter(Modal1);
